export const GET_CUSTOMER_LISTINGS = "GET_CUSTOMER_LISTINGS"
export const DELETE_CUSTOMER_LISTING = "DELETE_CUSTOMER_LISTING"
export const GET_CUSTOMER_LIVE_LISTINGS = "GET_CUSTOMER_LIVE_LISTINGS"
export const GET_CUSTOMER_SOLD_LISTINGS = "GET_CUSTOMER_SOLD_LISTINGS"
export const UPDATE_STATUS = "UPDATE_STATUS"
export const DUPLICATE_CUSTOMER_LISTING = "DUPLICATE_CUSTOMER_LISTING"
export const LISTING_LAYOUT_CURRENT_COMP = "LISTING_LAYOUT_CURRENT_COMP"